import { GetContextMenuItemsParams } from "ag-grid-community";
import {
  defaultExpandedRowContext,
  IdefaultExpandedRowContext,
} from "../../ActionSummaryTableHelperFunctions";
import { viewIcon } from "@/components/icons/SVGIcons";
import { getAllocationData } from "@/store/tradeDataStoreACTIONS";
import { getBlocksData } from "@/store/tradeBlockDataStoreACTIONS";


export function returnViewOrCloseAllocations(
  params: GetContextMenuItemsParams<any, any>,
  expandedRowsContext: IdefaultExpandedRowContext[],
) {
  const currentExpandedRowsContext = [...expandedRowsContext];
  const findSettingsForCurrentESID = currentExpandedRowsContext.find(
    (expandedSetting) => {
      return expandedSetting.esid == params.node?.data.esid;
    },
  );
  if (findSettingsForCurrentESID == undefined) {
    return "View Allocations";
  }
  return findSettingsForCurrentESID.allocationsShowing
    ? "Close Allocations"
    : "View Allocations";
}

export function returnAllocationsViewerArray({
  params,
  expandedRowsContext,
  setExpandedRowsContext,
  setExpandedRowsContextMostRecentlyUpdated,
  getAccessTokenSilently,
}: any) {
  return {
    name: returnViewOrCloseAllocations(params, expandedRowsContext),
    icon: viewIcon,
    cssClasses: ["viewAllocationsActionButton"],
    action: async () => {
      params.node.setExpanded(true);
      const currentExpandedRowsContext = [...expandedRowsContext];
      const findSettingsForCurrentESID = currentExpandedRowsContext.find(
        (expandedSetting) => {
          return expandedSetting.esid == params.node.data.esid;
        },
      );
      if (findSettingsForCurrentESID == undefined) {
        // Add a new obj if needed.
        const newSettings = { ...defaultExpandedRowContext };
        newSettings.esid = params.node.data.esid; // Different at ER/BLOCK
        newSettings.allocationsShowing = true;
        setExpandedRowsContext([...currentExpandedRowsContext, newSettings]);
      } else {
        const adjustedCurrentSettingsArray = currentExpandedRowsContext.map(
          // Adjust current settings.
          (settingsObj) =>
            settingsObj.esid == findSettingsForCurrentESID!.esid
              ? {
                  ...settingsObj,
                  allocationsShowing: !settingsObj.allocationsShowing,
                  editPanelShowing: false,
                  legsShowing: false,
                }
              : settingsObj,
        );
        setExpandedRowsContext(adjustedCurrentSettingsArray);
      }
      setExpandedRowsContextMostRecentlyUpdated(params.node.data.esid); // String to trigger flag of which row to redraw.
      const allocations = await getAllocationData({
        esid: params.node.data.esid,
        getAccessTokenSilently: getAccessTokenSilently,
        role: params.node.data.role,
        originatingCounterparty: params.node.data.originatingCounterparty
          ? params.node.data.originatingCounterparty
          : "",
      });
      // Historical rows are not in tradeDataStore, so the store update never reaches them.
      const gridNode: any = params.api?.getRowNode(params.node.data.esid);
      if (!gridNode) return;
      gridNode.setData({ ...gridNode.data, allocations });
      if (gridNode.detailNode) {
        params.api.redrawRows({ rowNodes: [gridNode.detailNode] });
      }
    },
  };
}

export function returnViewOrCloseLegs(
  params: GetContextMenuItemsParams<any, any>,
  expandedRowsContext: IdefaultExpandedRowContext[],
) {
  const currentExpandedRowsContext = [...expandedRowsContext];
  const findSettingsForCurrentESID = currentExpandedRowsContext.find(
    (expandedSetting) => {
      return expandedSetting.esid == params.node?.data.esid;
    },
  );
  if (findSettingsForCurrentESID == undefined) {
    return "View Legs";
  }
  return findSettingsForCurrentESID.legsShowing ? "Close Legs" : "View Legs";
}

export function returnLegsViewerArray({
  params,
  expandedRowsContext,
  setExpandedRowsContext,
  setExpandedRowsContextMostRecentlyUpdated,
  getAccessTokenSilently,
}: any) {
  return {
    name: returnViewOrCloseLegs(params, expandedRowsContext),
    icon: viewIcon,
    cssClasses: ["viewLegsActionButton"],
    action: async () => {
      params.node.setExpanded(true);
      const currentExpandedRowsContext = [...expandedRowsContext];
      const findSettingsForCurrentESID = currentExpandedRowsContext.find(
        (expandedSetting) => {
          return expandedSetting.esid == params.node.data.esid;
        },
      );
      if (findSettingsForCurrentESID == undefined) {
        // Add a new obj if needed.
        const newSettings = { ...defaultExpandedRowContext };
        newSettings.esid = params.node.data.esid; // Different at ER/BLOCK
        newSettings.legsShowing = true;
        setExpandedRowsContext([...currentExpandedRowsContext, newSettings]);
      } else {
        const adjustedCurrentSettingsArray = currentExpandedRowsContext.map(
          // Adjust current settings.
          (settingsObj) =>
            settingsObj.esid == findSettingsForCurrentESID!.esid
              ? {
                  ...settingsObj,
                  legsShowing: !settingsObj.legsShowing,
                  editPanelShowing: false,
                  allocationsShowing: false,
                }
              : settingsObj,
        );
        setExpandedRowsContext(adjustedCurrentSettingsArray);
      }
      setExpandedRowsContextMostRecentlyUpdated(params.node.data.esid); // String to trigger flag of which row to redraw.
      await getBlocksData({
        esid: params.node.data.esid,
        getAccessTokenSilently: getAccessTokenSilently,
      });
      // Redraw directly via the grid API once block data has arrived, so leg
      // column visibility (e.g. ISIN, coupon) reflects the freshly-loaded
      // blocks instead of the empty data present on the initial expand.
      // (Re-toggling setExpandedRowsContextMostRecentlyUpdated here doesn't
      // work: React/Zustand batch the "" -> esid flip back to the same value
      // it already held, so the effect watching it never re-fires.)
      const gridNode: any = params.api?.getRowNode(params.node.data.esid);
      if (gridNode?.detailNode) {
        params.api.redrawRows({ rowNodes: [gridNode.detailNode] });
      }
    },
  };
}

// 14868 - Revert code related to "/Trade/Execution/Recoupon" and ReCoupon flow.
// export function returnRecouponArray({
//   params,
//   expandedRowsContext,
//   setExpandedRowsContext,
//   setExpandedRowsContextMostRecentlyUpdated,
//   getAccessTokenSilently,
// }: any) {
//   return {
//     name: "Recoupon",
//     // icon: viewIcon,
//     action: () => {
//       params.node.setExpanded(true);
//       let currentExpandedRowsContext = [...expandedRowsContext];
//       let findSettingsForCurrentESID = currentExpandedRowsContext.find(
//         (expandedSetting) => {
//           return expandedSetting.esid == params.node.data.esid;
//         },
//       );
//       if (findSettingsForCurrentESID == undefined) {
//         // Add a new obj if needed.
//         let newSettings = { ...defaultExpandedRowContext };
//         newSettings.esid = params.node.data.esid; // Different at ER/BLOCK
//         newSettings.legsShowing = true;
//         setExpandedRowsContext([...currentExpandedRowsContext, newSettings]);
//       } else {
//         let adjustedCurrentSettingsArray = currentExpandedRowsContext.map(
//           // Adjust current settings.
//           (settingsObj) =>
//             settingsObj.esid == findSettingsForCurrentESID!.esid
//               ? {
//                   ...settingsObj,
//                   legsShowing: !settingsObj.legsShowing,
//                   editPanelShowing: false,
//                   allocationsShowing: false,
//                 }
//               : settingsObj,
//         );
//         setExpandedRowsContext(adjustedCurrentSettingsArray);
//       }
//       setExpandedRowsContextMostRecentlyUpdated(params.node.data.esid); // String to trigger flag of which row to redraw.
//       getBlocksData({
//         esid: params.node.data.esid,
//         getAccessTokenSilently: getAccessTokenSilently,
//       });
//     },
//   };
// }
